import { Controller } from "@hotwired/stimulus"

// Toggles per-kind options panels on the new-export form.
// Wiring on the form (see app/views/tools/exports/new.html.erb):
//   - <form data-controller="export-form">
//   - <input type="radio" name="export[kind]"
//            data-action="change->export-form#updateKind">
//   - <fieldset data-export-form-target="panel"
//               data-export-form-kind="ld50">  (or "oel_ade_calcs")
//
// Each panel declares the kind it belongs to via data-export-form-kind.
// On connect and on every radio change, this controller hides any panel
// whose declared kind doesn't match the currently checked radio value.
//
// The server still sanitizes options by kind on submit, so this is
// purely cosmetic — disabled JS leaves the form usable.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.updateKind()
  }

  updateKind() {
    const kind = this.#selectedKind()
    if (!kind) return

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.exportFormKind !== kind
    })
  }

  #selectedKind() {
    const checked = this.element.querySelector(
      'input[type="radio"][name="export[kind]"]:checked'
    )
    return checked ? checked.value : null
  }
}
